<template>
  <div class="m-product-short-info">
    <div class="product__meta">
      <div
        v-if="product.format_mm"
        class="product__dimensions"
      >{{ dimensionsLabel }}</div>
      <AProductRating
        @click="scrollToReviews"
        :reviews="reviews"
      >
        {{ $t('Leave a review') }}
      </AProductRating>
    </div>

    <div
      class="product__short-description"
      v-if="product.short_description"
    >
      <div
        v-html="product.short_description"
      ></div>
      <a
        href="#product-description"
        class="link-arrow-right"
      >Mehr anzeigen</a>
    </div>
  </div>
</template>

<script>
import { SfHeading, SfIcon, SfPrice, SfButton } from '@storefront-ui/vue';
import AProductRating from 'theme/components/atoms/a-product-rating';
import { optionLabel } from '@vue-storefront/core/modules/catalog/helpers';

import { createSmoothscroll } from 'theme/helpers'
export default {
  name: 'MProductShortInfo',
  components: {
    SfHeading,
    SfIcon,
    AProductRating
  },
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    customOptions: {
      type: Object,
      default: () => ({})
    },
    reviews: {
      type: Array,
      default: () => []
    },
    stock: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    reviewsCount () {
      return this.reviews.length
    },
    dimensionsLabel () {
      const label = this.optionLabel('format_mm') || ''
      // Magento option labels are inconsistent: some already include "mm".
      return /mm\s*$/i.test(label) ? label : `${label} mm`
    }
  },
  methods: {
    scrollToReviews () {
      this.$parent.$refs.productReviews.scrollIntoView()
    },
    optionLabel (attr) {
      return optionLabel(
        this.$store.state.attribute,
        { attributeKey: attr, optionId: this.product[attr] }
      )
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/helpers/breakpoints";
@import "~@storefront-ui/shared/styles/helpers/typography";

.product {
  &__drag-icon {
    animation: moveicon 1s ease-in-out infinite;
  }
}

@keyframes moveicon {
  0% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(0, 30%, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
</style>
